import React, { FC } from 'react';
import { ButtonContainer, ButtonLoadingIcon } from './Button.styles';
import { ButtonLoadingProps, ButtonProps } from './types';
import styled, { css } from 'styled-components';

export const Button: FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'medium',
  icon,
  ...props
}) => {
  return (
    <ButtonContainer
      variant={variant}
      size={size}
      iconOnly={!children}
      {...props}
    >
      <span>
        {icon}
        {children}
      </span>
    </ButtonContainer>
  );
};

// NOTE: ReferenceError: Cannot access 'Button' before initialization. Cannot place this on the styled component file
const ButtonLoadingContainer = styled(Button)<{ $loading: boolean }>`
  ${(p) =>
    p.$loading &&
    css`
      pointer-events: none;

      > span {
        visibility: hidden;
      }
    `}
`;

export const ButtonLoading: FC<ButtonLoadingProps> = ({
  loading = false,
  children,
  ...props
}) => {
  return (
    <ButtonLoadingContainer {...props} $loading={loading}>
      {loading && <ButtonLoadingIcon />}
      {children}
    </ButtonLoadingContainer>
  );
};
